import React from 'react';
import Banner from './Banner/Banner';
import Foods from './Foods/Foods';

const Home = () => {
    return (
        <div>
            <Banner />
            <Foods />
        </div>
    );
};

export default Home;